export default {
    es: {
        invalid_rut: 'Ingrese un RUT válido',
    },
    en: {
        invalid_rut: 'Enter a valid RUT',
    }
};
